import { generateCSV, saveExcel } from "./export-to-csv-native";
import moment from "moment";

export default function exportToCSVInventory(tableColumns,rawData, callback, location, label, dispatch, ActionTypes, isAIReport) {
  const now = moment().format("MMDDYYYY");
  if(label.toUpperCase() === "RTC TRADES") {
    let columnHeders = [];

    if (tableColumns && tableColumns.length > 0) {
      tableColumns.forEach(v => columnHeders.push({ header: v.key, key: v.key }));
    } else {
      const totalKeys = new Set();
      rawData.forEach(current => {
        Object.keys(current).forEach(key => totalKeys.add(key));
      });
  
      totalKeys.forEach(key => columnHeders.push({ header: key, key: key }));
    }
  
    const dateKeys = ['RTC_RESPONSE_UPDATED_DATE', 'ACTION_REQUIRED_DATE', 'RECEIVED_DATE', 'TRADE_CREATED_DATE'];
    const csvData = rawData?.map(data => {
      dateKeys.forEach(dateKey => {
        if (data[dateKey]) {
          data[dateKey] = new Date(data[dateKey]);
        }
      });
      return data;
    });
  
    if (!csvData.length) return false;
  
    let exportTitle = isAIReport ? label : `${label}_export_${now}`;
  
    saveExcel({
      workBookName: exportTitle,
      data: csvData,
      workSheetName: label,
      columns: columnHeders,
      dispatch: dispatch,
      ActionTypes: ActionTypes
    })
  } else {
    let columnHeders = []
    tableColumns?.map(v => columnHeders.push({
      header: v.key, key: v.key
    }))
  
    if(columnHeders?.length === 0){
      const totalKeys = {};
      rawData.reduce((acc, current) => {
        const keys = Object.keys(current);
        for (var i in keys) {
          totalKeys[keys[i]] = 1;
        }
      }, totalKeys);
  
      var keys = Object.keys(totalKeys);
      for (var i in keys) {
        columnHeders.push({
          header: keys[i], key: keys[i]
        })
      }
    }
  
    let csvData = rawData?.map(data => data)
  
    if (!csvData.length) return false;
  
    // generateCSV({
    //   headers: columnHeders,
    //   data: csvData,
    //   filename: `${label}_export_${now}`,
    //   columnDelimiter: ",",
    // });
  //   callback("done");
    let exportTitle = isAIReport ? label :  `${label}_export_${now}`
    saveExcel({
      workBookName: exportTitle,
      data: csvData,
      workSheetName: label,
      columns: columnHeders,
      dispatch: dispatch,
      ActionTypes: ActionTypes
    })
  }
 

}
